module.exports = __webpack_public_path__ + "static/media/b2.8d600257.svg";